/** @griffel:css-start [d] null **/
.fyind8e{color:var(--colorBrandForegroundLink);}
.f1iuv45f{text-decoration-line:none;}
.f1k6fduh{cursor:pointer;}
.f13mvf36{text-decoration-line:underline;}
/** @griffel:css-end **/
/** @griffel:css-start [h] null **/
.f1deo86v:hover{color:var(--colorBrandForegroundLinkHover);}
.f1tx3yz7:hover{text-decoration-line:underline;}
/** @griffel:css-end **/
/** @griffel:css-start [i] null **/
.f1u5sdlw:focus-visible{outline-width:var(--strokeWidthThick);}
.f1u8i3ug:focus-visible{outline-style:solid;}
.fvi4nxw:focus-visible{outline-color:var(--colorStrokeFocus2);}
/** @griffel:css-end **/
/** @griffel:css-start [i] {"p":-1} **/
.f7k1yb4:focus-visible{border-radius:var(--borderRadiusSmall);}
/** @griffel:css-end **/